"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertDataToFloat64Array = void 0;
function convert(value = []) {
    return !ArrayBuffer.isView(value) && value ? Float64Array.from(value) : value;
}
function convertDataToFloat64Array(data) {
    return {
        x: convert(data.x),
        re: convert(data.re),
        im: convert(data?.im),
    };
}
exports.convertDataToFloat64Array = convertDataToFloat64Array;
